import { render, staticRenderFns } from "./DocumentFile.vue?vue&type=template&id=150a5b55&scoped=true"
import script from "./DocumentFile.vue?vue&type=script&lang=js"
export * from "./DocumentFile.vue?vue&type=script&lang=js"
import style0 from "./DocumentFile.vue?vue&type=style&index=0&id=150a5b55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150a5b55",
  null
  
)

export default component.exports